<template>
    <div v-if="readcard.open && (!readcard.classify || readcard.classify !== 'bluetooth')" class="swipe">
        <template v-if="!ifFeild">
            <div class="readcard-img">
                <img :src="readcard.loadpic" />
            </div>
            <div class="readcard-text">{{readcard.loadnotic}}</div>
            <input v-model="readcardInput"
                v-if="readcard.open && (!readcard.classify || readcard.classify === 'IC')"
                :autofocus="true"
                class="readcard-input"
                type="text"
                ref="readcardInput"
                @keyup.enter="readcardFun"
                @focus="readcardFocus"
                @blur="readcardBlur" />
            <!-- <div v-if="!isReadcard"
                class="readcard-text">
                刷卡无效点击<span>这里</span>重新刷卡
            </div> -->
            <div v-if="readcard.classify && readcard.classify === 'idCard'" class="swipe-b">
                <el-button size="small" @click="getIdCard" type="primary">点击获取信息</el-button>
            </div>
            <div v-else class="swipe-b">
                <el-button size="small" @click="focusInput" type="primary">点击</el-button>
            </div>
        </template>
        <div v-else class="swipe-ss">
            <div class="swipe-ss-tt">写入读取信息</div>
            <div class="swipe-ss-tt">
                <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
            </div>
            <el-checkbox-group v-model="feildCheck" @change="handleCheckedCitiesChange">
                <el-checkbox v-for="list in readcard.feildList || []" :key="list.field" :label="list.field">
                    {{ defaultLabel[list.card] }}
                </el-checkbox>
            </el-checkbox-group>
            <!-- <div v-for="list in readcard.feildList || []" :key="list.field">
                {{ defaultLabel[list.card] }}
            </div> -->
            <div class="swipe-ss-ff">
                <el-button size="small" type="primary" @click="yesFb">确定</el-button>
                <el-button size="small" @click="closeFb">取消</el-button>
            </div>
        </div>
    </div>
</template>
    
<script>
import Axios from 'axios'
export default {
    name: 'swipeComp',
    props: {
        readcard: {
            type: Object,
            default: () => {
                return {
                    open: false,
                    classify: 'IC',
                    feildList: [],
                    commit: 1,
                    loadnotic: '',
                    loadpic: ''
                }
            }
        },
        showCard: {
            type: Boolean,
            default: true
        },
    },
    data () {
        return {
            readcardInput: '',
            isReadcard: false,
            ifFeild: false,
            feildValue: {},
            defaultLabel: {
                cardno: '身份证号',
                name: '姓名',
                photobase64: '照片',
                address: '地址',
                sex: '性别',
                nation: '民族',
                born: '出生日期',
                userlifeb: '有效期限开始时间',
                userlifee: '有效期限结束时间',
                police: '签发机关'
            },
            feildCheck: [],
            isIndeterminate: false,
            checkAll: false
        }
    },
    watch: {
        showCard: {
            immediate: true,
            handler (val) {
                if(!val){
                    this.ifFeild = true
                }
            }
        }
    },
    methods: {
        handleCheckAllChange(val) {
            const cityOptions = this.readcard.feildList.map(it => it.field)
            this.feildCheck = val ? cityOptions : [];
            this.isIndeterminate = false;
        },
        handleCheckedCitiesChange(value) {
            let checkedCount = value.length;
            this.checkAll = checkedCount === this.readcard.feildList.length;
            this.isIndeterminate = checkedCount > 0 && checkedCount < this.readcard.feildList.length;
        },
        focusInput () {
            this.$refs.readcardInput.focus()
        },
        yesFb () {
            const cc = {}
            for (const i of this.feildCheck) {
                cc[i] = this.feildValue[i]
            }
            this.$emit('upSwipe', cc)
            this.closeFb()
        },
        closeFb () {
            this.feildValue = {}
            this.feildCheck = []
            this.isIndeterminate = false
            this.checkAll = false
            this.ifFeild = false
        },
        async getIdCard () {
            if (!this.readcard.feildList || this.readcard.feildList.length === 0) {
                this.$message.warning('绑定字段不存在')
                return
            }
            const res = await Axios('http://localhost:8989/api/ReadMsg').catch(err => {
                console.log(err)
                this.$message.error('读卡器未检测到身份证！！')
            })

            if (res && res.data && res.data.code && res.data.code == 0) {
                const obj = {}
                for (const i of this.readcard.feildList) {
                    let vv = res.data[i.card]
                    // 时间转化下
                    if (i.card === 'born' || i.card === 'userlifeb' || i.card === 'userlifee') {
                        vv = this.inverTime(vv)
                    }
                    // 图片走一次上传逻辑
                    if (i.card === 'photobase64') {
                        vv = 'data:image/jpeg;base64,' + vv
                        const blob = this.base64ImgtoFile(vv,'name')
                        const name = 'name.jpg'
                        const file = new File([blob], name, {
                            type: 'image/jpeg'
                        })
                        const formData = new FormData()
                        const token = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')).accesstoken : ''
                        formData.append("file", file)
                        let url = '/userfile/upload?accesstoken='+token
                        let config = {
                            headers:{
                            'Content-Type':'multipart/form-data',
                            },
                        };
                        const rr = await Axios.post(url, formData, config).catch(err => {
                            console.log('图片上传错误', err)
                        })
                        if (rr.data) {
                            const st = '/userfiles/' + rr.data
                            const token = JSON.parse(localStorage.getItem('user')).accesstoken
                            vv = [{ name: 'photobase64.jpg', response: st, url: this.$url + st + '?accesstoken=' + token}]
                        }
                    }
                    obj[i.field] = vv
                }
                if (this.readcard && this.readcard.commitFeild && this.readcard.commitFeild === 2) {
                    this.feildValue = obj
                    this.ifFeild = true
                } else {
                    this.$emit('upSwipe', obj)
                }
            } else {
                this.$message.error(res && res.message || '刷卡错误，请重试！')
            }
        },
        base64ImgtoFile(dataurl, filename = 'file') {
            const arr = dataurl.split(',')
            const mime = arr[0].match(/:(.*?);/)[1]
            const suffix = mime.split('/')[1]
            const bstr = atob(arr[1])
            let n = bstr.length
            const u8arr = new Uint8Array(n)
            while (n--) {
                u8arr[n] = bstr.charCodeAt(n)
            }
            return new File([u8arr], `${filename}.${suffix}`, {
                type: mime
            })
        },
        inverTime (val) {
            if (!val) return val
            val = val.toString()
            return val.substring(0, 4) + '-' + val.substring(4,6) + '-' + val.substring(6,8)
        },
        readcardFun (val) {
            console.log('readcardFun', val)
            if (typeof val === 'object') {
                const el = val.target || val.srcElement
                val = el._value || el.value
            }
            if (this.readcard && this.readcard.classify) {
                if (!this.readcard.feildList || this.readcard.feildList.length === 0) {
                    this.$message.warning('绑定字段不存在')
                    return
                }
                const obj = {}
                for (const i of this.readcard.feildList) {
                    obj[i.field] = val
                }
                this.$emit('upSwipe', obj)
            } else {
                const obj = {}
                obj[this.readcard.feild] = val
                this.$emit('upSwipe', obj)
            }
        },
        readcardFocus () {
            console.log('聚焦')
            this.readcardInput = ''
            this.isReadcard = true
        },
        readcardBlur () {
            console.log('刷卡，失焦')
            this.isReadcard = false
        }
    }
}
</script>

<style scoped lang="scss">
    .swipe-ss {
        height: calc(100% - 30px);
        padding-top: 30px;
        position: relative;
        .swipe-ss-tt {
            font-size: 16px;
            font-weight: bold;
            text-align: left;
            padding-left: 30px;
            padding-bottom: 10px;
        }
        ::v-deep .el-checkbox-group {
            text-align: left;
            padding-left: 30px;
        }
        ::v-deep .el-checkbox {
            display: block;
            padding-bottom: 5px;
        }
        .swipe-ss-ff {
            position: absolute;
            bottom: 10px;
            text-align:center;
            width:100%;
        }
    }
    .swipe {
        width: 347px;
        min-width: 347px;
        text-align: center;
        background: #fff;
        display: flex;
        flex-direction: column;
        justify-content: center;
        border-left: 1px solid #D8D8D8;
        position: relative;
        .readcard-text {
            color: #666666;
            font-weight: 400;
            font-size: 18px;
            padding-top: 17px;
        }
        .readcard-input {
            position: absolute;
            left: 0;
            top: 0;
            width: 100%;
            opacity: 0;
            cursor: pointer;
        }
        .swipe-b {
            padding-top: 30px;
        }
    }
</style>
